import { Injector, inject } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { ClinicCatalogService } from '../clinic-catalog.service';

export function injectClinicCatalogInfoQuery(injector = inject(Injector)) {
  const clinicCatalogService = injector.get(ClinicCatalogService);

  return injectQuery(
    () => ({
      queryKey: ['content-management', 'catalogs', 'clinic', 'info'],
      staleTime: 600_000,
      queryFn: () => lastValueFrom(clinicCatalogService.getClinicCatalogInfo()),
      refetchOnWindowFocus: false,
    }),
    injector,
  );
}
